import * as React from 'react';
export var AlertContainer = function (_a) {
    var children = _a.children, _b = _a.severity, severity = _b === void 0 ? 'default' : _b;
    return (React.createElement(React.Fragment, null, children && (React.createElement("div", { className: "alert alert-".concat(severity, " alert-with-icon") },
        React.createElement("i", { className: "icon-budicon-".concat(severity === 'warning' ? '354' : '724', " alert-icon") }),
        React.createElement("div", { className: "alert-content", dangerouslySetInnerHTML: {
                __html: children,
            } })))));
};
